<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        SKU Variant Images
      </div>
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>

    <template>
      <v-card>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row class="text-center py-0">
              <v-col
                cols="12"
                sm="6"
                class="pb-0"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
              >
                <v-autocomplete
                  v-model="client"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  class="required pb-0"
                  @focus="fetchClientList"
                  @change="getStores(client)"
                  :rules="[(v) => !!v || 'Client is required.']"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  @change="getSkuDropDownList"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="type"
                  :items="imagesType"
                  item-text="text"
                  item-value="value"
                  label="Type of Images"
                  class="required pb-0"
                  :rules="[(v) => !!v || 'Type is required.']"
                  outlined
                  @change="
                    sku = null;
                    sku_variant_id = null;
                  "
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="sku"
                  :items="skuList"
                  item-text="sku_code"
                  item-value="id"
                  label="Select Sku"
                  class="required pb-0"
                  @input="getSkuDropDownListVariant(1)"
                  :rules="[(v) => !!v || 'Sku is required.']"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="sku_variant_id"
                  :items="sku_variants"
                  item-text="variant_sku_code"
                  item-value="id"
                  label="Select Variant SKU"
                  class="pb-0"
                  outlined
                  @change="getSkuDropDownListVariant(2)"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="selectedLinkedImages"
                  :items="unmapped_sku_images"
                  item-text="image_path"
                  item-value="id"
                  label="Select Unlinked Images"
                  class="pb-0"
                  outlined
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="selectedImages"
                  :items="mapped_sku_images"
                  item-text="image_path"
                  item-value="id"
                  label="Select Linked Images"
                  class="pb-0"
                  outlined
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-file-input
                  v-model="images"
                  label="Upload Images"
                  accept="image/*"
                  multiple
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera"
                  @change="onFilesChange"
                  outlined
                ></v-file-input>
              </v-col>
              <v-row v-if="imageUrls.length">
                <v-col
                  v-for="(url, index) in imageUrls"
                  :key="index"
                  cols="12"
                  md="6"
                  lg="4"
                  sm="6"
                  class="d-flex align-center"
                >
                  <v-img
                    :src="url"
                    max-width="300"
                    class="my-4"
                    max-height="300"
                  ></v-img>
                  <v-btn
                    color="error"
                    icon
                    small
                    class="ml-0 pl-0"
                    @click="deleteImage(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-col cols="12" sm="12" class="pt-0 text-left">
                <v-btn
                  class="success"
                  @click="saveForm()"
                  v-if="
                    checkPermission('app_sku_variant:b2b_sku_image_link_unlink')
                  "
                  :loading="downloader"
                  >Submit</v-btn
                >
                <v-btn
                  color="white"
                  :class="userCategory.user_category == 1 ? 'ml-0' : 'ml-4'"
                  @click="reset()"
                  >Cancel</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  created() {
    if (this.$store.getters.user.user_category == 1) {
      this.client = this.$store.getters.user.id;
      this.getStores(this.client);
    } else {
      this.fetchClientList();
    }
  },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    infor_storer_id: "",
    stores: [],
    clients: [],
    client: null,
    skuList: [],
    skuImages: [],
    selectedImages: null,
    selectedLinkedImages: null,
    sku: "",
    type: "",
    downloader: false,
    statuses: [
      {
        name: "Active",
        value: "1",
      },
      {
        name: "InActive",
        value: "0",
      },
    ],
    images: [],
    sku_variant_id: "",
    sku_images: [],
    sku_variants: [],
    imagesType: [],
    selectedAction: "",
    actions: ["Link", "Unlink", "Upload"],
    unmapped_sku_images: [],
    imageUrls: [],
    mapped_sku_images: [],
  }),

  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getPriceRateList",
      "fetchClient",
      "uploadSkuBB",
      "getSkuDropDown",
      "linkedSkuBB",
      "getChannelDropdownBB",
    ]),
    onFilesChange() {
      // this.imageUrls = [];
      if (this.images && this.images.length) {
        this.images.forEach((file) => {
          this.imageUrls.push(URL.createObjectURL(file));
        });
      }
    },
    deleteImage(index) {
      +this.imageUrls.splice(index, 1);
      +this.images.splice(index, 1);
    },
    getSkuDropDownListVariant(type) {
      if (this.client) {
        let payload = {
          client_id: this.client,
          sku_id: this.sku,
          sku_type: type,
          sku_variant_id: this.sku_variant_id || undefined,
          image_type: this.type || undefined,
        };
        payload = Object.entries(payload).reduce((acc, [key, value]) => {
          if (value !== null && value !== "") {
            acc[key] = value;
          }
          return acc;
        }, {});
        this.getSkuDropDown(payload).then((res) => {
          if (res.data.sku_variant) this.sku_variants = res.data.sku_variant;
          this.unmapped_sku_images = res.data.unmapped_sku_images;
          this.mapped_sku_images = res.data.mapped_sku_images;
        });
      }
    },
    getStores(id) {
      this.getChannelDropdownBB(id).then((res) => {
        this.stores = res.data;
      });
      this.userCategory.access_rights.permission_key.findIndex((e) => {
        if (e == "app_sku_variant:warehouse_dropdown") {
          this.imagesType.push({ text: "Warehouse", value: "warehouse" });
        }
        if (e == "app_sku_variant:Catalogues_type") {
          this.imagesType.push({ text: "Catalogues", value: "catalogues" });
        }
      });
    },
    getSkuDropDownList() {
      if (this.client) {
        let payload = {
          client_id: this.client,
          storer_id: this.infor_storer_id,
        };
        this.getSkuDropDown(payload).then((res) => {
          this.skuList = res.data.sku;
        });
      }
    },
    saveForm() {
      if (this.$refs.form.validate()) {
        this.downloader = true;
        let formData = new FormData();
        formData.append("client_id", this.client);
        formData.append("type", this.type);
        formData.append("b2b_sku_id", this.sku);
        if (
          this.selectedLinkedImages == null &&
          this.selectedImages == null &&
          this.images.length == 0
        ) {
          this.snackBar({
            color: "error",
            message: "Please select atleast one image",
          });
          return;
        }
        if (this.selectedImages) {
          formData.append("unlinked_image_id", this.selectedImages);
        }
        if (this.selectedLinkedImages) {
          formData.append("linked_image_id", this.selectedLinkedImages);
        }
        formData.append("variant_sku_id", this.sku_variant_id);
        this.images.forEach((image) => {
          formData.append(
            "images",
            image,
            `${image.name}`,
            `image/${image.type}`
          );
        });

        this.linkedSkuBB(formData)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.client = null;
            this.$refs.form.reset();

            this.$router.push("/skulist");
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    reset() {
      this.$refs.form.reset();
      this.downloader = false;

      this.$router.push("/skulist");
    },

    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          variant: "1",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
</style>
